import type { PropsWithChildren } from 'react';

export const HeaderSwitchWrapper = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-[30px] min-h-0 shrink-0 self-center whitespace-nowrap">
      <div className="flex h-full min-h-0 items-stretch">{children}</div>
    </div>
  );
};
